import React, { useEffect, useRef, useState } from 'react';
import {
  BottomSheetChildren,
  BottomSheetContent,
  BottomSheetHeader,
  BottomSheetHeaderBlock,
  BottomSheetLineSeparator,
  BottomSheetOverlay,
  BottomSheetTitle,
  BottomSheetWrapper,
} from './styled.bottomSheet';
import { useTranslation } from 'react-i18next';
import { IBottomSheet } from '../../../@types/bottomSheet';

export function BottomSheet ({
  isOpen,
  onClose,
  title,
  children,
  isLineSeparated = true,
}: IBottomSheet) {
  const { t } = useTranslation();
  const bottomSheetContentRef = useRef<HTMLDivElement>(null);
  const [bottomSheetheight, setBottomSheetheight] = useState<
    React.MutableRefObject<HTMLDivElement | undefined> | number
  >(0);

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('no-scroll');
    }

    if (bottomSheetContentRef && bottomSheetContentRef.current) {
      setBottomSheetheight(
        isOpen ? bottomSheetContentRef.current.scrollHeight : 0
      );
    }

    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, [isOpen]);

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <>
      <BottomSheetWrapper data-testid="bottom-sheet" height={bottomSheetheight}>
        <BottomSheetContent ref={bottomSheetContentRef}>
          <BottomSheetHeaderBlock>
            <BottomSheetHeader
              data-testid="bottom-sheet-cancel"
              onClick={handleClose}
            >
              {t('COMMON.BOTTOM_SHEET.CANCEL')}
            </BottomSheetHeader>
            {isLineSeparated && <BottomSheetLineSeparator />}
            {title && <BottomSheetTitle>{title}</BottomSheetTitle>}
          </BottomSheetHeaderBlock>
          <BottomSheetChildren
            data-testid="bottom-sheet-children"
            hasExtraPaddingTop={isLineSeparated}
          >
            {children}
          </BottomSheetChildren>
        </BottomSheetContent>
      </BottomSheetWrapper>
      {isOpen && (
        <BottomSheetOverlay
          data-testid="bottom-sheet-overlay"
          onClick={handleClose}
        />
      )}
    </>
  );
}
